import TempCache from '../core/enums/TempCache';
import BaseClass from '../core/BaseClass';
import WidgetTypes from '../core/enums/WidgetTypes';
import SimpleView from '../core/SimpleView';
import Utils from '../core/Utils';
import WidgetStates from '../core/hooks/WidgetStates';
import addClass from '../core/hooks/addClass';
import createArraySessionStorage from '../core/hooks/createArraySessionStorage';
import logIt from '../../logIt';

export default class PokeMessageView extends BaseClass {
    constructor(options) {
        super(options);
        const me = this;
        me.widget = WidgetTypes.PokeMessagesOverLay;
        me.context = options.context;
        me.identifier = options.identifier;
        me.overLayTargetElementSelector = options.overLayTargetElementSelector;
        me.overLayTemplate = options.overLayTemplate;
        me.messageContainer = options.messageContainer;
        me.messageTargetElementSelector = options.messageTargetElementSelector;
        me.messageTemplate = options.messageTemplate;
        me.BackButtonSelector = options.btnBackSelector;
        me.overlayDisplayClass = options.overlayDisplayClass;
        me.pokeHistory = createArraySessionStorage(me, 'livechat_pokeHistory');
        logIt('PokeMessageView init');
        me.avoidDuplicationById = options.avoidDuplicationById || true;
        me.avoidDuplicationByText = options.avoidDuplicationByText || true;
    }

    setOverLay() {
        const me = this;
        if (me.overlay) {
            // dbl check to make sure overlay doesn't get displayed when already shown
            return false;
        }
        me.overlay = new SimpleView({
            // a model less markup to contain individual messages
            context: me.context,
            identifier: me.identifier,
            targetElementSelector: me.overLayTargetElementSelector,
            template: me.overLayTemplate,
            model: me.model.overLayModel,
            afterRender() {
                addClass(
                    me.context.querySelector(me.overLayTargetElementSelector),
                    me.overlayDisplayClass
                );
                me.bindEvents();
            }
        });
    }

    setModel(model) {
        const me = this;
        me.model = model;
    }

    bindEvents() {
        const me = this;
        const $BackBtn = ApexChat.ApexChatJquery(me.BackButtonSelector, me.context);
        $BackBtn.on('click', (arg) => {
            // saving the last respond time of visitor via PokeOverLay Button
            ApexChat.storageAPI.Store(
                TempCache.POKE_MESSAGE_LastJoinBackTime,
                new Date().getTime()
            );
            me.publish({
                event: WidgetTypes.PokeMessagesOverLay + WidgetStates.Hidden,
                data: {}
            });
        });
        $BackBtn.trigger('focus');
    }

    show() {
        const me = this;
        me.setOverLay();
    }

    isTextDuplicate(msg) {
        const me = this;

        if (me.pokeHistory.indexOf(msg, 'text') == -1) {
            me.pokeHistory.add(msg);
            return false;
        }
        return true;
    }

    isIdDuplicate(msg) {
        const me = this;
        const pokeMsgPrefix = '#apexChat_poke_msg_';
        if (ApexChat.ApexChatJquery(pokeMsgPrefix + msg.id, me.context).length) {
            return true;
        }
        return false;
    }

    render(messageModel) {
        const me = this;
        // avoid duplication based on message id matching
        if (me.avoidDuplicationById && me.isIdDuplicate(messageModel)) {
            return;
        }
        // avoid duplication based on message text matching
        if (me.avoidDuplicationByText && me.isTextDuplicate(messageModel)) {
            return;
        }

        const singleMsgView = new SimpleView({
            context: me.context,
            identifier: me.messageContainer,
            targetElementSelector: me.messageTargetElementSelector,
            template: me.messageTemplate,
            model: messageModel,
            wrap: true,
            beforeRender() {
                this.template = this.template(this.model);
            }
        });
    }
}
